<template>
	<page>
		<module height="auto" :title="'订单：'+orderDetail.order_number+' 详情'">
			<div class="flex-between">
				<dl class="order-info">
					<dt>交易信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>订单编号：</label>
							<p>{{orderDetail.order_number}} <a @click="$copy(orderDetail.order_number)">复制</a></p>
						</div>
						<div class="order-info-item flex">
                            <label>下单时间：</label>
                            <p>{{orderDetail.create_date}} <!-- <a>更多</a> --></p>
                        </div>
                        <div class="order-info-item flex">
                            <label>订单备注：</label>
                            <p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
                        </div>
                    </dd>
				</dl>
			</div>
		</module>
		
		<module>
			<div class="order-detail">
				<c-table v-if="orderDetail" :data="productList" :paging="false" border>
					<c-table-column
						label="商品信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="110"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="单价"
					>
						<template v-slot="{data}">
							￥{{data.product_unit_price}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="小计"
					>
						<template v-slot="{data}">
                            ￥{{data.product_cost_money}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="已发货"
					>
						<template v-slot="{data}">
							<span style="color:#598419;;font-size:22px;" v-if="data.send_count>0">{{data.send_count}}</span>
							<span v-else>{{data.send_count}}</span>
						</template>
					</c-table-column>
					<c-table-column
						label="待发货"
					>
						<template v-slot="{data}">
							<span style="color:red;font-size:22px;" v-if="(data.product_count - data.send_count - data.total_refund_count)>0">{{data.product_count - data.send_count - data.total_refund_count}}</span>
							<span v-else>{{data.product_count - data.send_count - data.total_refund_count}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
				</c-table>
			</div>
			
			<template slot="button">
				<c-button color="main" v-if=" orderDetail.delivery_state == 1 && (orderDetail.order_state == 2 || (orderDetail.order_state == 3 && orderDetail.deliver_state =='部分发货'))" size="form" @click="orderSendHandle()">发货</c-button>
			</template>
		</module>
		
		<!--订单发货弹框（部分发货） -->
		<c-dialog ref="orderSend" title="订单发货" width="900" button-name="发货" @resolve="orderSendHandle">
			<div style="background: #FAFAFA;">
				<c-form ref="orderSendForm" column="2">
					<c-form-item label="物流公司">
						<c-select :value="lastLogisticsCompany" name="logistics_company_id" :options="logisticsCompany"></c-select>
					</c-form-item>
					<c-form-item label="运单号">
						<c-input name="logistics_number"></c-input>
					</c-form-item>
				</c-form>
			</div>
			<c-table ref="orderSendList" :data="sendList" height="320" :paging="false">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					width="300"
				>
                    <template #default="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
				</c-table-column>
				
				<c-table-column
					label="规格信息"
					name="product_sku_spec"
				></c-table-column>
				
				<c-table-column
					label="未发数量"
				>
					<template v-slot="{data}">
						×{{data.product_quantity}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="发货数量"
					width="150"
				>
					<template v-slot="{data, selected}">
						<c-input v-model="sendNum[data.product_sku]" type="number" width="100" :limit="[1, data.product_quantity]" :disabled="!selected" style="width:130px;" unit="件"/>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		
		<!--订单发货弹框（全部发货） -->
		<c-dialog ref="orderSendAll" title="订单发货" width="500" button-name="发货" @resolve="orderSendAllHandle">
			<div style="background: #FAFAFA;">
				<c-form ref="orderSendAllForm">
					<c-form-item label="物流公司">
						<c-select :value="lastLogisticsCompany" name="logistics_company_id" :options="logisticsCompany"></c-select>
					</c-form-item>
					<c-form-item label="运单号">
						<c-input name="logistics_number"></c-input>
					</c-form-item>
				</c-form>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	
	export default {
		components: {
			productInfo
		},
		
		props: {
			orderNumber: String
		},
		
		data() {
			return {
				orderDetail: '',
				productList: [],
				invoiceDate:'',
				realityMoney: 0,
				sendList: [],
				lastLogisticsCompany: '',
				logisticsCompany: [],
				sendNum: {},
				orderRemark: '',
				cancel_reason: '',
				order_remark: ''
			}
		},
		
		computed: {
			
		},
		
		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},
		
		mounted() {
			this.getOrderDetail();
		},
		
		methods: {
			//获取订单详情数据，按商家查询
			getOrderDetail() {
				this.request({
					url: '/purchase/order/detail_delivery',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
					}
				});
			},
			
			//订单发货（部分发货）
			orderSendHandle(stop) {
				if (!stop) {
					if (!this.logisticsCompany.length) {
						this.request({
							url: '/standard_logistics/all',
							success: data => {
								this.logisticsCompany = Array.from(data, item => {
									return {
										name: item.logistics_name,
										value: item.id
									};
								});
								this.$nextTick(() => {
									this.lastLogisticsCompany = this.orderDetail.last_logistics_company;
								});
							}
						});
					}
					
					this.request({
						url: '/purchase/order/undelivered/product/list',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.sendList = data;
							this.$refs.orderSendForm.clear();
							this.$refs.orderSend.open();
							//赋值默认发货数量
							this.sendList.forEach(item => {
								this.sendNum[item.product_sku] = item.product_quantity;
							});
							
						}
					});
				} else {
					stop();
					
					let form = this.$refs.orderSendForm.get(),
						list = this.$refs.orderSendList.getRow('selected');
					
					new Promise(resolve => {
						if (!form.logistics_company_id) {
							resolve('请选择物流公司');
						}

                        if (!form.logistics_number && form.logistics_company_id > 0) {
							resolve('请填写运单号');
						}
						
						if (!list.length) {
							resolve('请选择要发货的商品');
						}
						
						if (list.find(item => {
							return (parseInt(this.sendNum[item.data.product_sku]) || 0) <= 0;
						})) {
							resolve('请填写已选商品的发货数量');
						}
						
						resolve(false);
					}).then(error => {
						if (error) {
							this.$message({
								message: error
							});
							return;
						}
						
						this.request({
							url: '/purchase/order/deliver',
							data: Object.assign(form, {
								order_number: this.orderNumber,
								send_products: Array.from(list, item => {
									return {
										product_sku: item.data.product_sku,
										send_quantity: parseInt(this.sendNum[item.data.product_sku])
									}
								})
							}),
							loading: true,
							success: data => {
								this.$refs.orderSend.close();
								this.$message({
									message: '发货成功'
								});
								this.getOrderDetail();
							}
						});
					});
				}
			},
			//订单发货（全部发货）
			orderSendAllHandle(stop) {
				if (!stop) {
					if (!this.logisticsCompany.length) {
						this.request({
							url: '/standard_logistics/all',
							success: data => {
								this.logisticsCompany = Array.from(data, item => {
									return {
										name: item.logistics_name,
										value: item.id
									};
								});
								this.$nextTick(() => {
									this.lastLogisticsCompany = this.orderDetail.last_logistics_company;
								});
							}
						});
					}
					this.$refs.orderSendAll.open();
				} else {
					stop();
					
					let form = this.$refs.orderSendAllForm.get();
					
					new Promise(resolve => {
						if (!form.logistics_company_id) {
							resolve('请选择物流公司');
						}

                        if (!form.logistics_number && form.logistics_company_id > 0) {
							resolve('请填写运单号');
						}
						resolve(false);
					}).then(error => {
						if (error) {
							this.$message({
								message: error
							});
							return;
						}
						
						this.request({
							url: '/purchase/order/deliverall',
							data: Object.assign(form, {
								order_number: this.orderNumber
							}),
							loading: true,
							success: data => {
								this.$refs.orderSendAll.close();
								this.$message({
									message: '发货成功'
								});
								this.getOrderDetail();
							}
						});
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-info {
			width: 500px;
			padding: 30px 30px;
			
			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
			
			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				p {
					a {
						color: #005CD9;
					}
				}
			}
		}
		
		&-detail {
			padding: 30px 30px 40px;
		}
		
		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;
			
			span {
				color: var(--color-main);
			}
			
			b {
				font-size: 16px;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 20px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;
		
		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		dd > div:nth-child(1) {
			margin-right 50px;
		}
		
		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;
			
			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}
			
			p {
				a {
					color: #005CD9;
				}
			}
		}
	}
	
	.invoice {
		font-size: 14px;
		color: #000;
		
		p {
			color:#666;
			height:30px;
		}
	}
</style>